import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { initGA4, trackPageView } from "@/lib/gtag";
import { initClarity } from "@/lib/clarity";
import { getConsent, onConsentChange, CONSENT_ACCEPTED } from "@/lib/consent";

// Single mount point for all analytics. GA4 + Clarity load ONLY after the user
// clicks Accept in the consent banner. Fires a GA4 page_view on every SPA route
// change (including first load after accept).
export default function Analytics() {
    const { pathname, search } = useLocation();
    const [consent, setConsentState] = useState(() => getConsent());

    // React to consent changes from the banner / "Cookie Preferences" link
    useEffect(() => onConsentChange(setConsentState), []);

    // Init GA4 + Clarity once, only after accept
    useEffect(() => {
        if (consent === CONSENT_ACCEPTED) {
            initGA4();
            initClarity();
        }
    }, [consent]);

    // Track page_view on every route change (only if accepted)
    useEffect(() => {
        if (consent === CONSENT_ACCEPTED) {
            trackPageView(pathname + search);
        }
    }, [pathname, search, consent]);

    return null;
}
